import React from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from "reactstrap";
import { TextField } from "@material-ui/core";
import _ from "lodash";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
let classes = makeStyles({
  option: {
    fontSize: 10,
    "& > span": {
      marginRight: 10,
      fontSize: 10,
    },
    backgroundColor: "white",
  },
  customTextField: {
    "& input::placeholder": {
      fontSize: "15px",
    },
  },
});

export default function GrievanceSearchModal(props) {
  const {
    modal,
    searchTermContract,
    searchTermArticle,
    stepsList,
    searchStep,
    toggle,
  } = props;
  return (
    <Modal
      size="xl"
      centered={true}
      autoFocus={true}
      isOpen={modal}
      toggle={toggle}
      backdrop="static"
    >
      <ModalHeader>Grievance Filter</ModalHeader>
      <ModalBody>
        <div className="col-md-12 float-left">
          <div className="col-md-4 float-left">
            <select
              className="browser-default custom-select"
              id="status"
              style={{
                color: props.searchTermStatus === "0" ? "#b7b7b7" : "#495057",
                border: "1px solid #C4C4C4",
                height: "41px",
                fontSize: "15px",
                marginTop: "0px",
              }}
              onChange={async (e) => {
                e.preventDefault();
                const selectedOption = e.target;
                selectedOption.style.color =
                  selectedOption.value === "0" ? "#b7b7b7" : "#495057";
                await props.filterMyRequest(e.target.value, "status", null);
              }}
              value={props.searchTermStatus}
            >
              <option value="0">Filter Status</option>
              {props.statuses.map((item, i) => {
                return (
                  <option value={_.toLower(item.status)}>{item.status}</option>
                );
              })}
            </select>
          </div>
          <div className="col-md-4 float-left">
            <Autocomplete
              id="region"
              size="small"
              value={props.regionValue}
              options={props.regions}
              style={{ fontSize: "15px" }}
              getOptionLabel={(option) => option.region || ""}
              onChange={async (e, value, reason) => {
                if (value) {
                  e.preventDefault();
                  await props.filterMyRequest(value.region, "region", value);
                } else {
                  await props.filterMyRequest("", "region", null);
                }
              }}
              renderInput={(params) => (
                <TextField
                  classes={{
                    root: classes.customTextField,
                  }}
                  {...params}
                  placeholder="Filter Region"
                  style={{ backgroundColor: "white" }}
                  variant="outlined"
                />
              )}
            />
          </div>
          <div className="col-md-4 float-left">
            <Autocomplete
              id="facility"
              size="small"
              value={props.facilityValue}
              options={props.facilities}
              style={{ fontSize: "15px" }}
              getOptionLabel={(option) => option.facility || ""}
              onChange={async (e, value, reason) => {
                if (value) {
                  e.preventDefault();
                  await props.filterMyRequest(
                    value.facility,
                    "facility",
                    value,
                  );
                } else {
                  await props.filterMyRequest("", "facility", null);
                }
              }}
              renderInput={(params) => (
                <TextField
                  classes={{
                    root: classes.customTextField,
                  }}
                  {...params}
                  placeholder="Filter Facility"
                  style={{ backgroundColor: "white" }}
                  variant="outlined"
                />
              )}
            />
          </div>
        </div>
        <div className="col-12 pt-2 float-left">
          <div className="col-md-4 float-left">
            <select
              className="browser-default custom-select"
              id="steps"
              style={{
                color:
                  searchStep === "0" || searchStep === ""
                    ? "#b7b7b7"
                    : "#495057",

                border: "1px solid #C4C4C4",
                height: "41px",
                fontSize: "15px",
              }}
              value={searchStep}
              onChange={async (e) => {
                e.preventDefault();

                await props.filterMyRequest(e.target.value, "steps", null);
              }}
            >
              <option value="">Select Step</option>
              {stepsList &&
                !_.isEmpty(stepsList) &&
                stepsList.map((item, i) => {
                  return (
                    <option value={_.toLower(item.name)}>{item.name}</option>
                  );
                })}
            </select>
          </div>
          <div className="col-md-4 float-left">
            <select
              className="browser-default custom-select"
              id="contract"
              style={{
                color:
                  searchTermContract === "0" || searchTermContract === ""
                    ? "#b7b7b7"
                    : "#495057",

                border: "1px solid #C4C4C4",
                height: "41px",
                fontSize: "15px",
              }}
              value={_.toLower(props.searchTermContract)}
              onChange={async (e) => {
                e.preventDefault();

                await props.filterMyRequest(e.target.value, "contract", null);
              }}
            >
              <option value="">Contract List</option>
              {props.contractList &&
                !_.isEmpty(props.contractList) &&
                props.contractList.map((item, i) => {
                  return <option value={item.id}>{item.contractName}</option>;
                })}
            </select>
          </div>
          <div className="col-md-4 float-left">
            {props.articlesList && !_.isEmpty(props.articlesList) && (
              <select
                className="browser-default custom-select"
                id="article"
                style={{
                  color:
                    searchTermArticle === "0" || searchTermArticle === ""
                      ? "#b7b7b7"
                      : "#495057",
                  border: "1px solid #C4C4C4",
                  height: "41px",
                  fontSize: "15px",
                }}
                value={_.toLower(props.searchTermArticle)}
                onChange={async (e) => {
                  e.preventDefault();
                  await props.filterMyRequest(e.target.value, "article", null);
                }}
              >
                <option value="">Article List</option>

                {props.articlesList.map((item, i) => {
                  return (
                    <option value={item.articleId}>{item.articleName}</option>
                  );
                })}
              </select>
            )}
          </div>
        </div>

        <div
          className="col-md-12 float-left"
          style={{ marginTop: "35px", marginLeft: "15px" }}
        >
          <Label>
            {" "}
            <b>Total Records :</b> {props.grievanceCount}{" "}
          </Label>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={props.handleClearSearch}>
          Clear Filters
        </Button>

        <Button color="secondary" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
}
